import { render, staticRenderFns } from "./CheckPassword.vue?vue&type=template&id=540d5856"
import script from "./CheckPassword.vue?vue&type=script&lang=js"
export * from "./CheckPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports